<!-- eslint-disable -->
<template>
  <v-row>
    <v-col cols="12">
      <!-- Loading -->
      <v-progress-circular
        v-if="loading"
        indeterminate
        color="primary"
        class="d-block mx-auto my-8"
      ></v-progress-circular>

      <template v-else>
        <!-- Tabs for different activity types -->
        <v-tabs v-model="activityTab" bg-color="white" color="primary" class="mb-4">
          <v-tab value="posts">{{ $t('profile.posts') }}</v-tab>
          <v-tab value="comments">{{ $t('profile.comments') }}</v-tab>
          <v-tab value="reactions">{{ $t('profile.reactions') }}</v-tab>
        </v-tabs>

        <v-window v-model="activityTab">
          <!-- Posts Tab -->
          <v-window-item value="posts">
            <div v-if="activity?.posts && activity.posts.length > 0">
              <post-card
                v-for="post in activity.posts"
                :key="post.postId"
                :post="post"
                class="mb-4"
              />
            </div>
            <v-alert v-else type="info">
              {{ $t('profile.noPosts') }}
            </v-alert>
          </v-window-item>

          <!-- Comments Tab -->
          <v-window-item value="comments">
            <v-card v-if="activity?.comments && activity.comments.length > 0">
              <v-list>
                <v-list-item
                  v-for="comment in activity.comments"
                  :key="comment.commentId"
                  class="comment-item"
                >
                  <v-list-item-title class="mb-2">
                    <span class="text-grey">{{ formatDate(comment.created_at) }}</span>
                    •
                    <router-link :to="`/wall#post-${comment.postId}`">
                      View post
                    </router-link>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <div class="comment-content pa-3 rounded">
                      {{ comment.content }}
                    </div>
                    <div class="text-caption text-grey mt-2">
                      On post by @{{ comment.postAuthorUsername }}
                    </div>
                  </v-list-item-subtitle>
                  <v-divider class="my-2"></v-divider>
                </v-list-item>
              </v-list>
            </v-card>
            <v-alert v-else type="info">
              {{ $t('profile.noComments') }}
            </v-alert>
          </v-window-item>

          <!-- Reactions Tab -->
          <v-window-item value="reactions">
            <v-card v-if="activity?.reactions && activity.reactions.length > 0">
              <v-list>
                <v-list-item
                  v-for="reaction in activity.reactions"
                  :key="reaction.reactionId"
                  class="reaction-item"
                >
                  <template v-slot:prepend>
                    <v-icon size="large">{{ reaction.reactionIcon }}</v-icon>
                  </template>

                  <v-list-item-title>
                    <span class="text-grey">{{ formatDate(reaction.created_at) }}</span>
                  </v-list-item-title>
                  
                  <v-list-item-subtitle>
                    <div class="mt-2">
                      {{ reaction.postContent?.substring(0, 100) }}...
                    </div>
                    <div class="text-caption text-grey mt-2">
                      Post by {{ reaction.postAuthorDisplayName }} (@{{ reaction.postAuthorUsername }})
                    </div>
                  </v-list-item-subtitle>

                  <template v-slot:append>
                    <v-btn
                      icon="mdi-open-in-new"
                      variant="text"
                      size="small"
                      :to="`/wall#post-${reaction.postId}`"
                    ></v-btn>
                  </template>

                  <v-divider class="my-2"></v-divider>
                </v-list-item>
              </v-list>
            </v-card>
            <v-alert v-else type="info">
              {{ $t('profile.noReactions') }}
            </v-alert>
          </v-window-item>
        </v-window>
      </template>
    </v-col>
  </v-row>
</template>

<script setup>
/* eslint-disable */
import { ref } from 'vue'
import PostCard from './PostCard.vue'

defineProps({
  activity: {
    type: Object,
    default: null
  },
  loading: {
    type: Boolean,
    default: false
  }
})

const activityTab = ref('posts')

const formatDate = (dateString) => {
  if (!dateString) return ''
  const date = new Date(dateString)
  const now = new Date()
  const diffMs = now - date
  const diffMins = Math.floor(diffMs / 60000)
  const diffHours = Math.floor(diffMs / 3600000)
  const diffDays = Math.floor(diffMs / 86400000)

  if (diffMins < 60) return `${diffMins} min ago`
  if (diffHours < 24) return `${diffHours} hours ago`
  if (diffDays < 7) return `${diffDays} days ago`
  
  return date.toLocaleDateString('da-DK', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  })
}
</script>

<style scoped>
.comment-content {
  background-color: #f5f5f5;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.comment-item,
.reaction-item {
  border-bottom: 1px solid #e0e0e0;
}

a {
  color: #4A8B7F;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}
</style>
